import { render, staticRenderFns } from "./OptionsTab.vue?vue&type=template&id=0febd41b&scoped=true&"
import script from "./OptionsTab.vue?vue&type=script&lang=js&"
export * from "./OptionsTab.vue?vue&type=script&lang=js&"
import style0 from "./OptionsTab.vue?vue&type=style&index=0&id=0febd41b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febd41b",
  null
  
)

component.options.__file = "OptionsTab.vue"
export default component.exports